import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withOrderFormContext } from '../../contexts'

const ShapeSelection = ({ availableShapes, selectedShape, setSelectedShape, setFrameSize }) => {
  const [hasMoreThanOneShape, setHasMoreThanOneShape] = useState(false)

  useEffect(() => {
    setHasMoreThanOneShape(!!availableShapes && availableShapes.length > 1)
  }, [availableShapes])

  const _onChooseShape = (shape) => {
    setFrameSize(null)
    setSelectedShape(shape)
  }

  const _getLabelClassName = (shape) => {
    return selectedShape
      ? shape === selectedShape
        ? 'Selected'
        : 'GrayOut'
      : ''
  }

  const _getMaybeBoxedClassName = (shape) => {
    return 'BOXED' === shape ? 'boxed':''
  }

  const _renderShape = (shape) => {
    if('ENV-ONLY' === shape) {
      return (
          <li
            key={shape}
            role="button"
            tabIndex="0"
            className="PaSelectOption"
          >
            <a style={{lineHeight: '30px'}} href="https://photomart.com.au/product/envelope-for-packaged-prints/" target="_blank" rel="noopener noreferrer">
              <strong className={`PaSelectOption__Label ${_getMaybeBoxedClassName(shape)}`}>
                Click here if you would like to buy only envelopes
              </strong>
            </a>
          </li>
      )
    }


    return (
        <li
            key={shape}
            role="button"
            tabIndex="0"
            className={`PaSelectOption ${_getLabelClassName(shape)}`}
            onClick={() => _onChooseShape(shape)}
        >
          <strong className={`PaSelectOption__Label ${_getMaybeBoxedClassName(shape)}`}>{shape}</strong>
        </li>
    )
  }

  return hasMoreThanOneShape
    ? (
      <section className="PaAttribute">
        <h4 className="PaAttributeName">
          <span>Shape* <span className="selected-attribute">{selectedShape || ''}</span></span>
        </h4>
        <div className="PaAttributeControl">
          <ul className="PaSelectOptions">
            {availableShapes.map(_renderShape)}
          </ul>
        </div>
      </section>
    ) : null
}

ShapeSelection.propTypes = {
  availableShapes: PropTypes.array,
  selectedShape: PropTypes.string,
  setSelectedShape: PropTypes.func.isRequired,
  setFrameSize: PropTypes.func.isRequired
}

export default withOrderFormContext(context => ({
  availableShapes: context.availableShapes,
  selectedShape: context.selectedShape,
  setSelectedShape: context.setSelectedShape,
  setFrameSize: context.setFrameSize
}))(ShapeSelection)
